import {
  IRegistrationDbCustomer,
  ICustomerObject,
} from 'pages/Shared/DealerCustomers/Models';
import { IDealerInfo } from 'slices/auth';

export function convertDbCustomerToNewCustomer(
  dbCustomer: IRegistrationDbCustomer,
  rootDealer: IDealerInfo | undefined
): ICustomerObject {
  return {
    dealerCustomerId: 0, // this will set later or not needed for DB customers
    dealerInfo: {
      id: rootDealer?.id ?? 0,
      dealerId: rootDealer?.dealerId ?? '',
      dealerName: rootDealer?.name ?? '',
    },
    customerInfo: {
      title: '',
      salutation: dbCustomer.salutation,
      firstName: dbCustomer.firstname,
      lastName: dbCustomer.lastname,
      position: dbCustomer.position,
      company: dbCustomer.company,
      contactInformation: {
        zipCode: dbCustomer.zipcode,
        city: dbCustomer.city,
        state: dbCustomer.region, // Assuming region is the state
        country: dbCustomer.country,
        phone: dbCustomer.phone,
        email: dbCustomer.email,
        webUrl: '',
        address1: dbCustomer.address_1,
        address2: dbCustomer.address_2,
        address3: dbCustomer.address_3,
        district: '',
        permissions: {
          showInfoToOutOfMaintenanceUsers: false,
        },
      },
      customerId: '',
    },
  };
}
